import React from 'react';

import { serpsRoutes } from '@/config';

import { CITY, SKILL } from '../../constants';
import { useSerpsMatch, useTopCategories } from '../../hooks';
import { capitalizeFirstLetter } from '../../utils';
import { TagList } from '../tag-list';

export const TopCategories: React.VFC = () => {
  const {
    cities,
    roles,
    employmentTypes,
    citiesNearby,
    relatedJobRolesBySkill,
    relatedSkillsByJobRole,
    topLocationsBySkill,
  } = useTopCategories();
  const hasCitiesNearby = citiesNearby.length > 0;
  const serps = useSerpsMatch();

  if (serps?.category === SKILL && serps?.subcategory === CITY) {
    return null;
  }

  return (
    <div data-cy="serps-top-categories-first-row">
      <TagList
        headerCopyKey="XJM_SEO_TOP_LOCATIONS_BY_SKILL"
        headerCopyValues={{ skill: capitalizeFirstLetter(serps?.categoryValue || '') }}
        list={topLocationsBySkill}
        route={serpsRoutes.skillCity}
        getRouteParams={(item) => ({ categoryValue: serps?.categoryValue, subcategoryValue: item.seoName })}
      />

      <TagList headerCopyKey="XJM_SEO_TOP_JOBS_TITLE" serpsList={roles} showCount="hide" showEmptyResults="show" />

      {hasCitiesNearby ? (
        <TagList
          headerCopyKey="XJM_SEO_TOP_CITIES_NEARBY_TITLE"
          list={citiesNearby}
          route={serpsRoutes.city}
          getRouteParams={(item) => ({ categoryValue: item?.seoName })}
          showCount="hide"
          showEmptyResults="show"
        />
      ) : (
        <TagList headerCopyKey="XJM_SEO_TOP_CITIES_TITLE" serpsList={cities} showCount="hide" showEmptyResults="show" />
      )}

      {!serps ? (
        <TagList
          headerCopyKey="XJM_SEO_TOP_JOBS_TYPES_TITLE"
          serpsList={employmentTypes}
          showCount="hide"
          showEmptyResults="show"
        />
      ) : null}

      <TagList
        headerCopyKey="XJM_SEO_RELATED_JOB_TITLES_BY_SKILL"
        headerCopyValues={{ skill: capitalizeFirstLetter(serps?.categoryValue || '') }}
        list={relatedJobRolesBySkill}
        route={serpsRoutes.role}
        getRouteParams={(item) => ({ categoryValue: item?.seoName })}
        showCount="hide"
        showEmptyResults="show"
      />

      <TagList
        headerCopyKey="XJM_SEO_RELATED_SKILLS_BY_JOB_ROLE"
        list={relatedSkillsByJobRole}
        route={serpsRoutes.skill}
        getRouteParams={(item) => ({ categoryValue: item?.seoName })}
        showCount="hide"
        showEmptyResults="show"
      />
    </div>
  );
};
